<template>
  <i class="fa" :class="iconClass"></i>
</template>

<script>
export default {
  props: ['task'],

  computed: {
    iconClass() {
      let strategy = {
        'closing-subscription': 'fa-book-reader',
        'due-content-reminder': 'fa-bullhorn',
        'due-reminder': 'fa-bell',
        'ending-subscription': 'fa-book-reader',
        'project-milestone': 'fas fa-tasks',
        'retention-touchpoint-task': 'fas fa-clock',
      }

      return strategy[this.task.attributes.category]
    }
  }
}
</script>
